// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__-DMjm","section":"Home_section__1uiwC"};